import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [modalState, setModalState] = useState({
    isOpen: false,
    message: '',
    title: '',
    content: null,
  });

  const showModal = useCallback((messageText, titleText = "Friend's Message") => {
    setModalState({
      isOpen: true,
      message: messageText,
      title: titleText,
      content: null,
    });
  }, []);

  const closeModal = useCallback(() => {
    setModalState({
      isOpen: false,
      message: '',
      title: '',
      content: null,
    });
  }, []);

  const handleShowMessage = useCallback((e, messageText, friendName = '') => {
    e.stopPropagation();
    showModal(messageText, friendName ? `${friendName}'s Message` : "Friend's Message");
  }, [showModal]);

  const contextValue = useMemo(() => ({
    showModal,
    closeModal,
    handleShowMessage,
  }), [showModal, closeModal, handleShowMessage]);

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
      <Modal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        message={modalState.message}
        title={modalState.title}
      >
        {modalState.content}
      </Modal>
    </ModalContext.Provider>
  );
}

export function useModal() {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}
